import { stringIdentifierBase64Serializer } from './string-identifier-base64-serializer';
import { stringIdentifierDateSerializer } from './string-identifier-date-serializer';
import { stringIdentifierNumberSerializer } from './string-identifier-number-serializer';
import { stringIdentifierStringSerializer } from './string-identifier-string-serializer';

export const StringIdentifierSerializers = {
    base64: stringIdentifierBase64Serializer,
    Date: stringIdentifierDateSerializer,
    number: stringIdentifierNumberSerializer,
    string: stringIdentifierStringSerializer,
} as const;
